import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';
import {
  PageHeader,
  TabContainer,
  Tab,
  Heading,
  Section,
  SimpleDataTable,
  DangerousWrapper,
  getFootnotes,
  clip,
  stripHTML
} from '@budget-monorepo/shared-ui';

import Layout from '../components/Layout';
import HelmetData from '../components/HelmetData';

const Section1A = (props) => {
  const { data, location } = props;
  // eslint-disable-next-line react/prop-types
  const { content, site } = data;
  // eslint-disable-next-line camelcase
  const { modifiedTime, mg_mod_date, mg_mod_datetime } = content.parent;
  const layoutProps = {
    activeIndex: 2,
    above: () => <PageHeader title={content.title} category={content.budgetSection} />,
    pageTitle: content.title,
    dataTimeStamp: modifiedTime,
    buildTimeStamp: site.buildTime
  };
  // metadata for the page
  const metaTitle = `${content.budgetSection}: ${content.title}`;
  const metaDescription = clip(stripHTML(content.summary), 160);
  return(
    <Fragment>
      <HelmetData {...{
        metaTitle,
        metaDescription,
        mg_mod_date,
        mg_mod_datetime
      }}
      />
      <Layout {...layoutProps}>
        <div className="page-content">
          <Section>
            <DangerousWrapper rawHtml={content.summary} />
          </Section>
          <Section>
            <Heading text={content.totalTable.title} level={4} />
            <SimpleDataTable title={`${content.title} ${content.totalTable.title}`} table={content.totalTable} maxColWidth={300} download={`${location.pathname}-${content.totalTable.title}`} />
          </Section>
          <Section>
            <TabContainer>
              {content.tables.map((tab, i) => {
                const key = `tab--${i}`;
                return(<Tab title={tab.title} key={key}><SimpleDataTable title={`${content.title} ${tab.title}`} table={tab} maxColWidth={150} download={`${location.pathname}-${tab.title}`} /></Tab>);
              })}
            </TabContainer>
          </Section>
          {content.footnotes && (
            <Section>
              {getFootnotes(content.footnotes)}
            </Section>
          )}
        </div>
      </Layout>
    </Fragment>
  );
};

Section1A.propTypes = {
  location: PropTypes.object,
  data: PropTypes.object
};

export default Section1A;

export const query = graphql`
  query Section1aQuery {
    site {
      ...SiteMetadata
    }
    content: pagesJson(fields: { slug: { eq: "/section-1a/" } }) {
      title
      budgetSection
      summary
      totalTable {
        title
        headers {
          name
          type
          align
          value
          footnote
        }
        total {
          source
          allBudgetedFunds
          generalFund
          commonwealthTransportationFund
          gamingLocalAidFund
          marijuanaRegulationFund
          other
        }
        data {
          source
          allBudgetedFunds
          generalFund
          commonwealthTransportationFund
          gamingLocalAidFund
          marijuanaRegulationFund
          other
        }
      }
      tables {
        title
        headers {
          name
          type
          align
          value
          footnote
        }
        total {
          source
          allBudgetedFunds
          generalFund
          commonwealthTransportationFund
          gamingLocalAidFund
          marijuanaRegulationFund
          other
        }
        data {
          source
          allBudgetedFunds
          generalFund
          commonwealthTransportationFund
          gamingLocalAidFund
          marijuanaRegulationFund
          other
        }
      }
      footnotes {
        index
        text
      }
      # Get the last modified timestamp for the file powering the page
      ...PagesJsonDataTimeStamp
    }
  }
`;
